// Top 20 Harz-Städte für Webdesign Landingpages
export interface HarzCity {
  id: string;
  name: string;
  slug: string;
  region: "ost" | "west";
  description: string;
  characteristics: string[];
  attractions: string[];
  businessContext: string;
}

export const HARZ_CITIES: HarzCity[] = [
  // Ost-Harz (10 Städte)
  {
    id: "blankenburg",
    name: "Blankenburg",
    slug: "blankenburg",
    region: "ost",
    description: "Historische Stadt mit Schloss im östlichen Harz",
    characteristics: ["Mittelalterliche Altstadt", "Burgenlandschaft", "Familienfreundlich"],
    attractions: ["Schloss Blankenburg", "Regenstein-Ruine", "Teufelsmauer"],
    businessContext: "Handwerk- und Tourismusbetriebe",
  },
  {
    id: "quedlinburg",
    name: "Quedlinburg",
    slug: "quedlinburg",
    region: "ost",
    description: "UNESCO Welterbe mit 1.300 Fachwerkhäusern",
    characteristics: ["UNESCO Welterbe", "Fachwerkaltstadt", "Künstlerstadt"],
    attractions: ["Fachwerk-Altstadt", "Schloss Quedlinburg", "Kunstgalerien"],
    businessContext: "Gastronomie, Kunsthandwerk, Premium-Einzelhandel",
  },
  {
    id: "thale",
    name: "Thale",
    slug: "thale",
    region: "ost",
    description: "Wildromantisches Harzer Tal mit Bodetal",
    characteristics: ["Kletterparadies", "Naturschutzgebiet", "Bergbahn"],
    attractions: ["Bodetal", "Hexentanzplatz", "Tropfsteinhöhlen"],
    businessContext: "Outdoor-Sportbetriebe, Wellness, Tourismus",
  },
  {
    id: "wernigerode",
    name: "Wernigerode",
    slug: "wernigerode",
    region: "ost",
    description: "Das Märchenschloss des Harzes - Kulturstadt",
    characteristics: ["Märchenschloss", "Harzer Schmalspurbahn", "Kulturstadt"],
    attractions: ["Schloss Wernigerode", "Altstadt", "Dampfbahn"],
    businessContext: "Tourismus, Gastronomie, Einzelhandel, Kunstgewerbe",
  },
  {
    id: "ilsenburg",
    name: "Ilsenburg",
    slug: "ilsenburg",
    region: "ost",
    description: "Wanderparadies im Tal der Ilse",
    characteristics: ["Naturwanderungen", "Wasserfälle", "Waldnähe"],
    attractions: ["Ilsefälle", "Heinrich-Heine-Weg", "Klosterruine"],
    businessContext: "Wandertourismus, Natur-Hotels, Wellness",
  },
  {
    id: "bad-suderode",
    name: "Bad Suderode",
    slug: "bad-suderode",
    region: "ost",
    description: "Kurort mit Sole- Therme und Bodesee",
    characteristics: ["Mineralquellen", "Thermalbad", "Kurpark"],
    attractions: ["Bodesee", "Kurpark", "Solequelle"],
    businessContext: "Wellness, Kur-Hotels, Spa-Services",
  },
  {
    id: "ballenstedt",
    name: "Ballenstedt",
    slug: "ballenstedt",
    region: "ost",
    description: "Residenzstadt mit Schlossanlage und Park",
    characteristics: ["Schlosspark", "Adelsgeschichte", "Kulturevents"],
    attractions: ["Schloss Ballenstedt", "Schlosspark", "Museum"],
    businessContext: "Kulturveranstaltungen, Premium-Gastronomie",
  },
  {
    id: "gernrode",
    name: "Gernrode",
    slug: "gernrode",
    region: "ost",
    description: "Kunststadt an der Selke mit Romanik",
    characteristics: ["Romanische Architektur", "Flussidyll", "Kunstallee"],
    attractions: ["St. Cyriakus Kirche", "Selketal", "Kunstallee"],
    businessContext: "Kunsthandwerk, Kulturelle Events, Gastronomie",
  },
  {
    id: "elbingerode",
    name: "Elbingerode",
    slug: "elbingerode",
    region: "ost",
    description: "Waldstadt mit beeindruckenden Tropfsteinhöhlen",
    characteristics: ["Tropfsteinhöhlen", "Stille Lage", "Waldreich"],
    attractions: ["Baumann-Höhle", "Hermannshöhle", "Waldpark"],
    businessContext: "Höhlen-Tourismus, Natur-Hotels, Gastgewerbe",
  },
  {
    id: "schierke",
    name: "Schierke",
    slug: "schierke",
    region: "ost",
    description: "Bergdorf mit direktem Brockenzugang",
    characteristics: ["Brockenzugang", "Wanderstart", "Bergluft"],
    attractions: ["Brocken-Bahn", "Fußweg Brocken", "Waldgebiet"],
    businessContext: "Berghotels, Wandertourismus, Restaurants",
  },

  // West-Harz (10 Städte)
  {
    id: "goslar",
    name: "Goslar",
    slug: "goslar",
    region: "west",
    description: "UNESCO Welterbe mit 1.000-jähriger Geschichte",
    characteristics: ["UNESCO Welterbe", "Kaiserpfalz", "Silberbergen"],
    attractions: ["Kaiserpfalz", "Altstadt", "Rammelsberg-Mine"],
    businessContext: "Kulturelle Institutionen, Premium-Tourismus, Handel",
  },
  {
    id: "bad-harzburg",
    name: "Bad Harzburg",
    slug: "bad-harzburg",
    region: "west",
    description: "Nordharzer Heilbad mit Thermalbad",
    characteristics: ["Heilbad", "Thermalbad", "Seilbahn"],
    attractions: ["Thermalbad", "Burgberg-Seilbahn", "Kurpark"],
    businessContext: "Wellness-Zentren, Kur-Hotels, Spa-Services",
  },
  {
    id: "hettstedt",
    name: "Hettstedt",
    slug: "hettstedt",
    region: "west",
    description: "Kupferstadt mit Bergbautradition am östlichen Harzrand",
    characteristics: ["Kupferbergbau", "Industriegeschichte", "Mansfelder Land"],
    attractions: ["Kupfermuseum", "Altstadt", "Bergbaudenkmäler"],
    businessContext: "Handwerk, Industrie, Dienstleistungen",
  },
  {
    id: "bad-lauterberg",
    name: "Bad Lauterberg",
    slug: "bad-lauterberg",
    region: "west",
    description: "Luftkurort mit Sole-Therme",
    characteristics: ["Sole-Bad", "Luftkurort", "Waldreich"],
    attractions: ["Sole-Therme", "Kurpark", "Wanderrouten"],
    businessContext: "Wellness-Zentren, Reha-Kliniken, Hotels",
  },
  {
    id: "clausthal-zellerfeld",
    name: "Clausthal-Zellerfeld",
    slug: "clausthal-zellerfeld",
    region: "west",
    description: "Bergbaustadt auf 630m mit TU Bergakademie",
    characteristics: ["Höchstgelegene Stadt", "Forschung", "Bergbaugeschichte"],
    attractions: ["Gebäudeensemble", "TU Campus", "Silbersee"],
    businessContext: "Tech-Handwerk, Bildung, Forschungs-Services",
  },
  {
    id: "osterode",
    name: "Osterode am Harz",
    slug: "osterode",
    region: "west",
    description: "Burgstadt im südlichen Harz",
    characteristics: ["Burgstadt", "Südharz-Zentrum", "Kunsthandwerk"],
    attractions: ["Burg Osterode", "Altstadt", "Kunstgewerbe"],
    businessContext: "Handel, Gastgewerbe, Kunsthandwerk",
  },
  {
    id: "herzberg",
    name: "Herzberg am Harz",
    slug: "herzberg",
    region: "west",
    description: "Südlichste Harzer Stadt mit Flair",
    characteristics: ["Südlichstes Harzzentrum", "Fürstlich", "Kulturstadt"],
    attractions: ["Schloss Herzberg", "Altstadt", "Marktplatz"],
    businessContext: "Kulturelle Events, Gastronomie, Kunsthandwerk",
  },
  {
    id: "braunlage",
    name: "Braunlage",
    slug: "braunlage",
    region: "west",
    description: "Premium-Kurort am Brockenrand (810m)",
    characteristics: ["Premium-Kurort", "Brocken-Nähe", "Skigebiet"],
    attractions: ["Wurmberg-Seilbahn", "Ski-Alpin", "Kurpark"],
    businessContext: "Premium-Hotels, Wellness-Zentren, Sporthotels",
  },
  {
    id: "hahnenklee",
    name: "Hahnenklee",
    slug: "hahnenklee",
    region: "west",
    description: "Hochlagen-Kurort mit See und Skipisten",
    characteristics: ["Hochlage", "Skigebiet", "Luftkurort"],
    attractions: ["Hahnenklee-See", "Skipisten", "Bergalm"],
    businessContext: "Sport-Hotels, Winter-Tourismus, Gastronomie",
  },
  {
    id: "st-andreasberg",
    name: "St. Andreasberg",
    slug: "st-andreasberg",
    region: "west",
    description: "Wintersport-Paradies mit Bergbau-Tradition",
    characteristics: ["Schneesicher", "Loipen", "Wintersport"],
    attractions: ["Skigebiete", "Loipen", "Museum"],
    businessContext: "Sport-Hotels, Winter-Tourismus, Gastronomie",
  },
];

export const getHarzCityBySlug = (slug: string): HarzCity | undefined => {
  return HARZ_CITIES.find((city) => city.slug === slug);
};

export const getHarzCitiesByRegion = (region: "ost" | "west"): HarzCity[] => {
  return HARZ_CITIES.filter((city) => city.region === region);
};
